import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// libraries
import $ from 'jquery';

import GenericFormPopUp from '../../generic_components/GenericFormPopUp';

import * as CONSTANTS from '../../constants';
import * as CONFIG from '../../config';
import * as UTILS from '../../utils/utilFunctions';
import TEXT_GENERAL from '../../text';

const CONTACT_TYPE_DROPDOWN_CONTENT = require('../../general/staticContent/contactTypeDropDown');
const BOOKING_DROPDOWN_CONTENT = require('../../general/staticContent/bookingDropDown');
const { getStatusOptionsForBooking } = require('../../general/staticContent/statusDropDown');

function prepareEmployeesKeyValuePairs(employees) {
  const mappedDropDownEntries = [];
  if (employees && employees.length > 0) {
    employees.forEach(employee => {
      if (employee.lastname) {
        const value = employee.id;
        const label = `${employee.firstname || ''} ${employee.lastname}`;
        const mappedEmployee = { value, label };
        mappedDropDownEntries.push(mappedEmployee);
      }
    });
  }
  return mappedDropDownEntries;
}
function prepareProjectsKeyValuePairs(projects) {
  const mappedDropDownEntries = [];
  if (projects && projects.length > 0) {
    projects.forEach(project => {
      if (project.id) {
        const value = project.id;
        const label = project.projectNumber;
        const mappedProject = { value, label };
        // prevent duplicates - only push to mapped array if entry doesn't exist yet
        if (!mappedDropDownEntries.map(entry => entry.value).includes(project.id)) mappedDropDownEntries.push(mappedProject);
      }
    });
  }
  return mappedDropDownEntries;
}

class CandidatePastContactCreatePopUpContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.form = this.generateFormFields();
    this.state = {};
    // error handling required for API calls
    this.errorHandling = UTILS.errorHandling.bind(this);
  }

  updateAPICall = updatedData => {
    const subSchemaData = updatedData;
    const payload = {
      candidateId: this.props.candidateId,
      subSchemaName: 'pastContacts',
      subSchemaData
    };
    if (Object.keys(updatedData).length > 0) {
      const tokenFromLocalStorage = window.sessionStorage.getItem('token');
      const url = CONSTANTS.addCandidateSubSchemaEntryURL;
      console.log(`API ${url} request`, payload);
      $.ajax({
        url,
        method: 'POST',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        headers: { 'x-auth': tokenFromLocalStorage },
        data: JSON.stringify(payload),
        timeout: CONFIG.ajaxTimeout
      })
        .done((responseBody, status) => {
          console.log(`API /${url} response`, responseBody, status);
          this.props.handleSnackbarOpen(TEXT_GENERAL.snackBarTexts.createSuccess);
          this.props.refreshCandidate();
          this.props.handleClose();
        })
        .fail(err => {
          this.errorHandling(err, url);
        });
    } else {
      this.props.handleSnackbarOpen(TEXT_GENERAL.snackBarTexts.noUpdate);
    }
  };

  generateFormFields() {
    const currentDate = UTILS.getCurrentDateFormattedForDateField();
    const forms = {
      formFields: {
        contactDate: {
          value: currentDate,
          label: 'Datum des Kontakts',
          type: 'date',
          required: true
        },
        intermediary: {
          value: this.props.userId,
          label: 'Durch',
          type: 'dropDown',
          content: prepareEmployeesKeyValuePairs(this.props.employees),
          required: true
        },
        contactType: {
          value: this.props.isPastContactDefaultPhoneCall ? 'telefonisch' : '',
          label: 'Art des Kontakts',
          type: 'dropDown',
          content: CONTACT_TYPE_DROPDOWN_CONTENT,
          required: true
        },
        project: {
          value: '',
          label: 'Auftrag',
          type: 'dropDown',
          content: prepareProjectsKeyValuePairs(this.props.projects),
          required: false
        },
        booking: {
          value: '',
          label: 'Buchung',
          type: 'dropDown',
          content: BOOKING_DROPDOWN_CONTENT
        },
        bookingStatus: {
          value: '',
          label: 'Buchungsstatus',
          type: 'dropDown',
          content: formFields => getStatusOptionsForBooking(formFields.booking.value),
          showIf: formFields => (formFields.booking.value || '').startsWith('Buchung Paket')
        },
        subject: {
          value: '',
          label: 'Betreff',
          customClass: 'col-12 mb-2'
        },
        comment: {
          value: '',
          label: 'Notiz',
          type: 'editor',
          customClass: 'col-12 mt-4 mb-2',
          additionalProps: { init: { height: 250 } }
        }
      }
    };

    return forms;
  }

  render() {
    const { projectNumber } = this.state;
    this.form = this.generateFormFields(projectNumber);
    return (
      <div>
        <GenericFormPopUp
          open={this.props.open}
          headlineText="Kontakthistorie"
          key="pastContact"
          genericFormProps={{
            formFields: this.form.formFields,
            handleSubmit: this.updateAPICall,
            handleClose: this.props.handleClose
          }}
        />
      </div>
    );
  }
}
CandidatePastContactCreatePopUpContainer.defaultProps = {
  isPastContactDefaultPhoneCall: false
};

CandidatePastContactCreatePopUpContainer.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,

  // data
  candidateId: PropTypes.string.isRequired,
  handleSnackbarOpen: PropTypes.func.isRequired,
  refreshCandidate: PropTypes.func.isRequired,
  employees: PropTypes.array.isRequired,
  projects: PropTypes.array.isRequired,
  isPastContactDefaultPhoneCall: PropTypes.bool,
  userId: PropTypes.string.isRequired
};

export default CandidatePastContactCreatePopUpContainer;
